import React, { useState, useEffect } from "react";
import MeetingItem from "./MeetingItem";
import AddMeetingModal from "./AddMeetingModal";
import api from '../../api/api';

const MeetingsCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [meetingsData, setMeetingsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMeetings = async () => {
    try {
      const res = await api.get('/meetings/');
      setMeetingsData(res.data);
    } catch (error) {
      console.error('Error fetching meetings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  if (loading) return <div className="p-4 text-center">در حال بارگذاری...</div>;

  return (
    <>
      <div className="bg-white p-6 rounded-3xl border border-slate-900/10 shadow-[0_0_25px_rgba(15,23,42,0.22)] flex flex-col h-[400px] md:h-full min-h-0 transition-all duration-300 hover:shadow-[0_0_35px_rgba(15,23,42,0.35)] ring-2 ring-blue-500/50" dir="rtl">
        <div className="flex justify-between items-center mb-6 flex-shrink-0">
          <h3 className="text-base font-bold text-slate-800">جلسات</h3>
          <div className="flex gap-2">
             <button onClick={() => setIsModalOpen(true)} className="text-gray-400 hover:text-indigo-600 text-xl cursor-pointer transition-colors p-1">＋</button>
             <button className="text-gray-400 hover:text-slate-700 font-bold cursor-pointer p-1">···</button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto min-h-0 pr-1 overscroll-contain touch-pan-y [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-slate-50 [&::-webkit-scrollbar-thumb]:bg-slate-200 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-slate-300">
          {meetingsData.map((meeting) => (
            <MeetingItem key={meeting.id} {...meeting} />
          ))}
        </div>
          </div>
    <AddMeetingModal
      isOpen={isModalOpen}
      onClose={() => { setIsModalOpen(false); fetchMeetings(); }}
    />
    </>
  );
};

export default MeetingsCard;